import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { Router, Params, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ToolEnum } from 'src/Models/Common';
import { TracAlertsModel } from 'src/Models/TracAlertsModel';
import { ActionItemService } from 'src/Services/actionitem.service';
import { CheckAuth } from 'src/Services/utility.service';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-manage-trac-it-alerts',
  templateUrl: './manage-trac-it-alerts.component.html',
  styleUrls: ['./manage-trac-it-alerts.component.css']
})
export class ManageTracItAlertsComponent implements OnInit {

  tokenKey: string = '';
  userId: number = 0;
  SelectedTool: string;
  productId: number = 1;
  multiSelectDropDownHeight: number = 200;


  TracAlertsModel = new TracAlertsModel()

  addUpdateTracItAlert = new FormGroup({
    actionId: new FormControl(''),
    deadlineDate: new FormControl(''),
    subject: new FormControl(''),
    description: new FormControl(''),
    isSendMail: new FormControl(''),
  });

  isTracItAlerts: boolean = true;
  actionId: number = 0;
  isDataLoad: boolean = false;
  isViewMode: boolean = false;

  isSendMail: boolean = true;

  pageNumber:number;
  pageSize:number;
  Email:string = '';
  Name:string = '';
  orderBy:string;

  constructor(private readonly activedRoute: ActivatedRoute,
    private readonly checkAuth: CheckAuth,
    private readonly actionItemServices: ActionItemService,
    private readonly toastr: ToastrService,
    private readonly router: Router,
    private readonly titleService: Title,
    private sessionStorageService: SessionStorageService
  ) {
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.tokenExpireCalculation(this.sessionStorageService.getAppStartTime(),this.sessionStorageService.getTokenExpiryValue());
    this.SelectedTool = this.sessionStorageService.getUserLoginTool();
    this.productId = ToolEnum.actionitem;
    this.titleService.setTitle('Manage Trac-It Alert');
  }

  ngOnInit() {
    this.pageNumber = 1;
    this.pageSize = 10;
    this.orderBy = 'ActionId ASC'
    this.activedRoute.params.subscribe((params: Params) => {

      if (params['id']) {
        if (params['id'] != null) {
          this.isTracItAlerts = false;
          this.actionId = params['id'];
          this.userId = params['userid'];
          this.GetTracItAlertsByIds();
        }
      }
      else {
        this.userId = 0;
      }
    });
  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }
  
  GetTracItAlertsByIds(): void {
    this.isDataLoad = true;
    this.actionItemServices.GetTracItAlertsByUser(this.tokenKey, this.actionId,this.pageNumber,this.pageSize,this.userId,this.orderBy).subscribe(
      data => {
        if (data["generalAlert"] != null && data["status"] != "Failure") {

          this.TracAlertsModel = data['generalAlert'].tractItAlerts[0];

          this.Email=this.TracAlertsModel.email;
          this.Name=this.TracAlertsModel.name;


          if (this.TracAlertsModel != null) { 
            let deadlineDate = new Date(this.TracAlertsModel.deadlineDate);

            let dd1 = deadlineDate.getDate().toString();
            if (parseInt(dd1.toString()) < 10)
              dd1 = '0' + dd1.toString();

             let mm1 = (deadlineDate.getMonth() + 1).toString();
            if (parseInt(mm1.toString()) < 10)
              mm1 = '0' + mm1.toString();

            this.TracAlertsModel.deadlineDate = mm1 + '/' + dd1 + '/' + deadlineDate.getFullYear();
          }

          this.addUpdateTracItAlert.setValue({
            actionId: this.TracAlertsModel.actionId,
            deadlineDate: this.TracAlertsModel.deadlineDate,
            subject: this.TracAlertsModel.subject,
            description: this.TracAlertsModel.description,
            isSendMail: this.TracAlertsModel.isSendMail,
          });

          this.isDataLoad = false;
        }
        else {
          this.isDataLoad = false;
          this.showMessage(data["message"], 'Error', 'error');
        }
      }, error => {
        this.isDataLoad = false;
        this.showMessage(error, 'Error', 'error');
      })

  }


  showMessage(msg: string, msgTitle: string, msgType: string) {
    if (msgType == 'success') {
      setTimeout(() => this.toastr.success(msg, msgTitle));
    }
    else if (msgType == 'error') {
      setTimeout(() => this.toastr.error(msg, msgTitle));
    }
  }

  isAlertDate(dateArray: any) {
    if (dateArray != null) {
      let dd1 = dateArray.getDate().toString();
      if (parseInt(dd1.toString()) < 10)
        dd1 = '0' + dd1.toString();

      let mm1 = (dateArray.getMonth() + 1).toString();
      if (parseInt(mm1.toString()) < 10)
        mm1 = '0' + mm1.toString();

      this.TracAlertsModel.deadlineDate = mm1 + '/' + dd1 + '/' + dateArray.getFullYear();
    }
    else
      this.TracAlertsModel.deadlineDate = null;
  }

  saveAddUpdateTracItAlert(addUpdateTracItAlert: any) {
    if (addUpdateTracItAlert.value['deadlineDate'] == '') {
      this.showMessage('Please select alert date', 'Error', 'error');
      return;
    }
    let currentDate = new Date();
    if (new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate()) > addUpdateTracItAlert.value["deadlineDate"]) {
      this.showMessage('Previous alert date not allow', 'Error', 'error');
      return;
    }

    if (addUpdateTracItAlert.value['subject'] == '' || typeof (addUpdateTracItAlert.value['subject']) == 'undefined') {
      this.showMessage('Please enter subject', 'Error', 'error');
      return;
    }
    if (addUpdateTracItAlert.value['subject'] != '') {
      if (addUpdateTracItAlert.value['subject'].toString().trim() == '') {
        this.showMessage('Please enter subject', 'Error', 'error');
        return;
      }
    }

    let planText = this.removeHTMLTags(addUpdateTracItAlert.value['description']);
    if (planText === false) {
      this.showMessage('Please enter description', 'Error', 'error');
      return;
    }
    if (planText != '') {
      if (planText.trim() == '') {
        this.showMessage('Please enter description', 'Error', 'error');
        return;
      }
    }

    if (typeof (addUpdateTracItAlert.value['actionId']) == 'undefined') {
      this.TracAlertsModel.actionId = 0;
    }
    else {
      this.TracAlertsModel.actionId = addUpdateTracItAlert.value['actionId'];
    }

    if (typeof (addUpdateTracItAlert.value['subject']) == 'undefined') {
      this.TracAlertsModel.subject = '';
    }
    else {
      this.TracAlertsModel.subject = addUpdateTracItAlert.value['subject'];
    }

    if (typeof (addUpdateTracItAlert.value['description']) == 'undefined') {
      this.TracAlertsModel.description = '';
    }
    else {
      this.TracAlertsModel.description = addUpdateTracItAlert.value['description'];
    }
    this.TracAlertsModel.isSendMail = this.isSendMail;
    this.TracAlertsModel.createdBy = this.userId;
    this.TracAlertsModel.modifiedBy = this.userId;
    this.TracAlertsModel.userId = this.userId;
    this.TracAlertsModel.productId= this.productId;

    this.actionItemServices.AddUpdateTracItAlerts(this.tokenKey, this.TracAlertsModel).subscribe(
      data => {
        if (data['status'] == 'Success') {
          this.showMessage('Trac-It alerts Updated successfully', 'Success', 'success');
          this.router.navigate(['/admin/trac-it/Trac-itAlerts']);
        }
        else
          this.showMessage(data['status'], 'Error', 'error');
      },
      error => {
        this.showMessage(error, 'Error', 'error');
      }
    );
  }
  
  removeHTMLTags(str) {
    if ((str === null) || (str === ''))
      return false;
    else
      str = str.toString();
    return str.replace(/<[^>]*>/g, '');
  }

  setSendEmailNotificationChecked($event) {
    this.isSendMail = $event.target.checked;
  }
}
